export const REFERRAL_LINK_BASE =
  process.env.REACT_APP_IB_REFERRAL_BASE || "https://tradeapp.com/ref/";

export function deriveReferralCode(u) {
  if (!u) return "AGENT_8492";
  const id =
    u.ID ??
    u.USER_ID ??
    u.UserId ??
    u.user_information?.USER_ID ??
    u.user_information?.ID ??
    u.userInformation?.USER_ID ??
    u.userInformation?.ID;
  if (id != null && String(id).trim() !== "") {
    const raw = String(id).trim();
    return raw.toUpperCase().startsWith("AGENT_") ? raw.toUpperCase() : `AGENT_${raw}`;
  }
  return "AGENT_8492";
}

export function getReferralDisplayBase() {
  return REFERRAL_LINK_BASE.replace(/\/?$/, "/");
}

/** Normalize user input to a referral suffix (AGENT_…). */
export function normalizeReferralSuffix(raw, user) {
  let v = String(raw || "").trim();
  if (!v) return deriveReferralCode(user);
  if (v.startsWith("http") && v.includes("/ref/")) {
    const idx = v.indexOf("/ref/");
    v = v.slice(idx + "/ref/".length).split(/[?#]/)[0];
  }
  v = v.replace(/^\/+/, "");
  return v.toUpperCase().startsWith("AGENT_")
    ? v.toUpperCase()
    : `AGENT_${v.replace(/^AGENT_/i, "")}`;
}

export function buildFullReferralUrl(code) {
  const base = getReferralDisplayBase();
  return `${base}${String(code || "").replace(/^\//, "")}`;
}

/** Origin + `/informationAccount/` — matches Accounts share & signup deep link. */
export function getInformationAccountLinkPrefix() {
  if (typeof window === "undefined" || !window.location) {
    return "/informationAccount/";
  }
  const origin = window.location.origin || "";
  return `${origin}/informationAccount/`;
}

function digitsOnly(s) {
  return String(s ?? "").replace(/\D/g, "");
}

/**
 * Default numeric broker/trading id for IB invite (session user).
 * Prefer broker/trading fields; else digits from user id or AGENT_ prefix code.
 */
export function deriveDefaultInviteAccountId(u) {
  if (!u) return "";
  const info = u.user_information || u.userInformation || {};
  const tryFields = [
    info.BROKER_ID,
    info?.REFERAL_BROKER,
    info?.REFERRAL_BROKER,
    u.BROKER_ID,
    info.TRADING_ID,
    u.TRADING_ID,
  ];
  for (const c of tryFields) {
    if (c == null || String(c).trim() === "") continue;
    const d = digitsOnly(c);
    if (d) return d;
  }
  const uid = info.USER_ID ?? u.USER_ID ?? info.ID ?? u.ID;
  const fromUser = digitsOnly(uid);
  if (fromUser) return fromUser;
  const agent = deriveReferralCode(u);
  const fromAgent = digitsOnly(String(agent).replace(/^AGENT_/i, ""));
  return fromAgent || "";
}

/**
 * Parse pasted full URL or raw input; keep digits only (editable suffix).
 */
export function normalizeInviteAccountIdDigits(raw) {
  let v = String(raw ?? "").trim();
  if (v.includes("/informationAccount/")) {
    const idx = v.indexOf("/informationAccount/");
    v = v.slice(idx + "/informationAccount/".length).split(/[?#]/)[0] || "";
    try {
      v = decodeURIComponent(v);
    } catch {
      // use raw segment
    }
  }
  const d = digitsOnly(v);
  return d;
}

export function buildInformationAccountInviteUrl(accountIdDigits) {
  const id = normalizeInviteAccountIdDigits(accountIdDigits);
  const prefix = getInformationAccountLinkPrefix();
  if (!id) return prefix.replace(/\/?$/, "/");
  return `${prefix}${encodeURIComponent(id)}`;
}

export async function copyTextToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (_) {
    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.setAttribute("readonly", "");
      ta.style.position = "fixed";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(ta);
      return ok;
    } catch {
      return false;
    }
  }
}
